import "./AboutContentStyle.css"
import  React1 from "../components/asserts/react1.jpg"
import  React2 from "../components/asserts/react2.webp"
import React from 'react'
import { Link } from "react-router-dom"

const AboutContent = () => {
  return (
    <div className="About">
      <div className="left">
          <h1>Who Am I?</h1>
          <p>Iam a react front-end developer. I create responsive
            secure websites for my clients</p>
            <Link to="/contact"><button className="btn">contact</button> </Link>
      </div>
      <div className="right">
         <div className="img-container">
          <div  className="img-stack top">
            <img src={React2} className="img" alt="true"/>
          </div>
          <div  className="img-stack bottom">
            <img src={React1} className="img" alt="true"/>
          </div>
         </div>
      </div>
    </div>
  )
}

export default AboutContent
